
























import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator';

/**
 * Selector de fecha en formato de input
 */
@Component
export default class DatePickerField extends Vue {
    @Prop()
    public value: string

    @Prop({default: 'Fecha'})
    public label: string

    public show = false
    public date = null
}
